import { Container } from 'react-bootstrap'
import { Col, Row } from 'react-bootstrap'
import React from 'react'
import "./wcu.styles.css"
import { useMediaQuery } from 'react-responsive'


export default function WCU() {
  const isMobile = useMediaQuery({ query: '(max-width: 450px)' })
  return (
    <div className="body-container">
      <Container className="wcu-container">
        <div className="wcu">
          <Container>
            <Row className='why_choose_div'>
              {isMobile ? (
                <Col xs={6} className="wcu-top-left">
                  <span>
                    <div>Why Choose <span style={{ color: "#F8C28F" }}>Us?</span></div>
                  </span>
                </Col>
              ) : (
                <Col xs={6} className="wcu-top-left">
                  <span>
                    <div>Why Choose</div>
                    <div>
                      <span style={{ color: "#F8C28F" }}>Us?</span>
                    </div>
                  </span>
                </Col>
              )}
              <Col xs={6} className="wcu-top-right">
                <span style={{ marginTop: "2rem" }}>
                  Doctors play a valuable role in the lives of our patients and their families. It is a privilege to know that our clients trust in our expertise. We exist to care for them when they are at their most vulnerable. We ensure that our patients receive cost-effective, quality care and outstanding client experiences.
                </span>
              </Col>
            </Row>
          </Container>
        </div>

        {/*<Row className="aoe-top-row" style={{ marginTop: "8rem" }}>
          <Col md={4}>
            <div className='div_AM' style={{ display: "flex", justifyContent: "flex-start" }}>
              <div ><img src={AM} alt="AM" /></div>
            </div>
            <div className="wcu-image-title" style={{ display: "flex", justifyContent: "flex-start" }}>Adolescent Medicine</div>
            <div className="wcu-image-sub-text" style={{ display: "flex", justifyContent: "flex-start" }}>Lorem ipsum dolor sit amet, consectetur adipiscing</div>
          </Col>
          <Col md={4}>
            <div className='div_AM' style={{ display: "flex", justifyContent: "flex-start" }}>
              <div ><img src={AM} alt="AM" /></div>
            </div>
            <div className="wcu-image-title" style={{ display: "flex", justifyContent: "flex-start" }}>Adolescent Medicine</div>
            <div className="wcu-image-sub-text" style={{ display: "flex", justifyContent: "flex-start" }}>Lorem ipsum dolor sit amet, consectetur adipiscing</div>
          </Col>
          <Col md={4}>
            <div className='div_AM' style={{ display: "flex", justifyContent: "flex-start" }}>
              <div ><img src={AM} alt="AM" /></div>
            </div>
            <div className="wcu-image-title" style={{ display: "flex", justifyContent: "flex-start" }}>Adolescent Medicine</div>
            <div className="wcu-image-sub-text" style={{ display: "flex", justifyContent: "flex-start" }}>Lorem ipsum dolor sit amet, consectetur adipiscing</div>
          </Col>
  </Row> */}
        {/* <Row className="wcu-bottom-row" style={{ marginTop: "8rem" }}>
          <Col md={4}>
            <div className='div_AM' style={{ display: "flex", justifyContent: "flex-start" }}>
              <div ><img src={AM} alt="AM" /></div>
            </div>
            <div className="wcu-image-title" style={{ display: "flex", justifyContent: "flex-start" }}>Adolescent Medicine</div>
            <div className="wcu-image-sub-text" style={{ display: "flex", justifyContent: "flex-start" }}>Lorem ipsum dolor sit amet, consectetur adipiscing</div>
          </Col>
          <Col md={4}>
            <div className='div_AM' style={{ display: "flex", justifyContent: "flex-start" }}>
              <div ><img src={AM} alt="AM" /></div>
            </div>
            <div className="wcu-image-title" style={{ display: "flex", justifyContent: "flex-start" }}>Adolescent Medicine</div>
            <div className="wcu-image-sub-text" style={{ display: "flex", justifyContent: "flex-start" }}>Lorem ipsum dolor sit amet, consectetur adipiscing</div>
          </Col>
          <Col md={4}>
            <div className='div_AM' style={{ display: "flex", justifyContent: "flex-start" }}>
              <div ><img src={AM} alt="AM" /></div>
            </div>
            <div className="wcu-image-title" style={{ display: "flex", justifyContent: "flex-start" }}>Adolescent Medicine</div>
            <div className="wcu-image-sub-text" style={{ display: "flex", justifyContent: "flex-start" }}>Lorem ipsum dolor sit amet, consectetur adipiscing</div>
          </Col>
</Row> */}
      </Container>
    </div>
  )
}
